import styled from "styled-components";
import { device } from "../../stylesheet/breakpoints";

export const AnswersWraper = styled.div`
  width: 100%; 
  /* height: 100%; */
  padding-bottom: 85px;

  @media ${device.desktop} {
    padding-bottom: 70px;
    width: 100%;
    /* overflow: hidden; */
    position: relative;

  }
`;

export const AnswersBoxRadioAndChecked = styled.ul`
  list-style: none;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  grid-gap: 10px 20px;
  margin: 0 auto;
  max-width: 100%;


  @media ${device.desktop} {
    max-height: 100%;
  }
`;

export const AnswersBoxRadioImage = styled.ul`
  list-style: none;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  justify-content: center;
  grid-gap: 10px;
  margin: 0 auto;
  max-width: 100%;

  @media ${device.desktop} {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    grid-gap: 30px 20px;

    height: 100%;
  }
`;

export const AnswersBoxSelect = styled.div`
  width: 100%;
  text-align: start;

  &:focus-visible {
    border: none;
    outline: none;
  }

  @media ${device.desktop} {
    padding-right: 14px;
  }
`;

export const AnswersBoxDate = styled.div`
  width: 100%;

  @media ${device.desktop} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    height: 100%;
  }
`;
